import { devLog } from '../../devLogger'

export const getErrorLogData = (err: unknown) => {
  const errorBody = {
    error: err instanceof Error ? err.message : JSON.stringify(err),
    errorBody: err && typeof err === 'object' && err !== null
      ? Object.entries(err).flatMap(([key, value]) => [
          key,
          value instanceof Error ? value.message : JSON.stringify(value),
        ]).join(', ')
      : JSON.stringify(err),
    errorStack:
      err instanceof Error
        ? err.stack ?? 'No stack trace'
        : 'Not an Error instance',
    errorType: err instanceof Object ? err.constructor?.name : typeof err,
    errorCause: err instanceof Error ? err.cause ?? 'Unknown cause' : 'Unknown cause',
  }

  devLog(err, typeof err, errorBody, JSON.stringify(errorBody), 'error logger in new relic')

  return errorBody
}
